<template>
    <el-container class="admin-layout">
        <el-aside width="220px" class="admin-sidebar">
            <div class="sidebar-brand">
                <i class="el-icon-menu brand-icon" />
                <span>卡密系统</span>
            </div>
            <el-menu
                :default-active="activeMenu"
                class="sidebar-menu"
                router
                background-color="#fff"
                text-color="#303133"
                active-text-color="#409EFF"
            >
                <el-menu-item index="/card-secret">
                    <i class="el-icon-document" />
                    <span slot="title">卡密信息管理</span>
                </el-menu-item>
                <el-menu-item index="/customer">
                    <i class="el-icon-user" />
                    <span slot="title">客户信息管理</span>
                </el-menu-item>
                 <el-menu-item index="/goods">
                    <i class="el-icon-goods" />
                    <span slot="title">商品信息管理</span>
                </el-menu-item>
                <el-menu-item index="/sms-template">
                    <i class="el-icon-message" />
                    <span slot="title">短信模板管理</span>
                </el-menu-item>
               
            </el-menu>
            <div class="sidebar-footer">
                <div class="user-block">
                    <el-avatar
                        :size="40"
                        src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
                    />
                    <div class="user-meta">
                        <div class="user-name">{{ displayName }}</div>
                        <div class="user-date">2026-05-05</div>
                    </div>
                </div>
                <el-button
                    type="text"
                    class="logout-btn"
                    icon="el-icon-switch-button"
                    @click="handleLogout"
                >
                    退出登录
                </el-button>
            </div>
        </el-aside>
        <el-main class="admin-main">
            <router-view />
        </el-main>
    </el-container>
</template>

<script>
import { getDisplayName, logout as authLogout } from '@/utils/auth'

export default {
    name: 'AdminLayout',
    computed: {
        activeMenu() {
            return this.$route.path
        },
        displayName() {
            return getDisplayName()
        }
    },
    methods: {
        handleLogout() {
            authLogout()
            this.$router.replace('/login').catch(() => {})
        }
    }
}
</script>

<style scoped lang="less">
.admin-layout {
    height: 100vh;
    background: #f0f2f5;
}

.admin-sidebar {
    background: #fff;
    border-right: 1px solid #ebeef5;
    display: flex;
    flex-direction: column;
    position: relative;
    height: 100%;
}

.sidebar-brand {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 20px 18px;
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    border-bottom: 1px solid #f0f0f0;
}

.brand-icon {
    font-size: 22px;
}

.sidebar-menu {
    flex: 1;
    border-right: none;
    padding-top: 8px;
}

.sidebar-menu .el-menu-item i {
    color: inherit;
}

.sidebar-footer {
    padding: 16px;
    border-top: 1px solid #f0f0f0;
    margin-top: auto;
}

.user-block {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
}

.user-meta {
    flex: 1;
    min-width: 0;
}

.user-name {
    font-size: 14px;
    font-weight: 500;
    color: #303133;
}

.user-date {
    font-size: 12px;
    color: #909399;
    margin-top: 2px;
}

.logout-btn {
    width: 100%;
    justify-content: flex-start;
    color: #606266 !important;
    padding-left: 0 !important;
}

.admin-main {
    padding: 20px 24px;
    overflow: auto;
    >div{
        height: 100%;
        display: flex;
        flex-direction: column;
        
    }
}

</style>
